module.exports = __webpack_public_path__ + "937d1c3e9bbbcdf15327964049823ecd.svg";